import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { PageBreadcrumb, ProductList, BrandSKUListHeader } from '../..'

const ITEMS_PER_PAGE = [
  20,
  40,
  60,
  80,
  100
]
const DEFAULT_SORTMODE_DESC = 1

const BrandItemPage = ({ brand, products, attributes, attribute_groups, lang, navigation }) => {
  let initialSortBy = 'date_add'
  let initialSortMode = DEFAULT_SORTMODE_DESC

  const [itemsPerPage, setItemsPerPage] = useState(ITEMS_PER_PAGE[2])
  const [sortBy, setSortBy] = useState(initialSortBy)
  const [sortMode, setSortMode] = useState(initialSortMode)

  return (
    <div className="product-list-4 product-list-breadcrumbs">
      <PageBreadcrumb
        lang={lang}
        current={{ title_nl: brand.name, title_en: brand.name, ...brand }}
        items={[ 'homepage', 'brands' ]}
        />

      <ProductList
        title={brand.name}
        products={products}
        attributes={attributes}
        attribute_groups={attribute_groups}
        lang={lang}
        navigation={navigation}
        keyPrefix="brand"
        header={<BrandSKUListHeader brand={brand} lang={lang} navigation={navigation} />}
        sortBy={sortBy} setSortBy={setSortBy}
        sortMode={sortMode} setSortMode={setSortMode}
        itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage}
        availableItemsPerPage={ITEMS_PER_PAGE} />
    </div>
  )
}

BrandItemPage.propTypes = {
  brand: PropTypes.object,
  products: PropTypes.array,
  attributes: PropTypes.array,
  attribute_groups: PropTypes.array,
  lang: PropTypes.object,
  navigation: PropTypes.object
}

export default BrandItemPage
